/**
 * RGR06 반품작업 엔드포인트. 1.0 God endpoint(`/api/grid/*`) 를 화면 전용 REST 로 전환한다(2장 1절).
 *
 * | 동작              | 2.0 API                                          | 1.0 대응                              |
 * |-------------------|---------------------------------------------------|----------------------------------------|
 * | HEAD 조회         | `GET /api/v1/return/work-scans/summary`           | `POST /api/grid/search` (RGR06_HEAD)   |
 * | ITEM 조회         | `GET /api/v1/return/work-scans`                   | `POST /api/grid/search` (RGR06_ITEM)   |
 * | 저장              | `POST /api/v1/return/work-scans/save`             | `POST /api/grid/save` (RGR06)          |
 * | 주문검색          | `GET /api/v1/return/management/order-search`      | `POST /api/common/search` (REF_NO3)    |
 * | 파일 업로드 1단계 | `POST /api/v1/common/file/uploads`                | `POST /api/common/resource`            |
 * | 파일 업로드 3단계 | `PATCH /api/v1/common/file/uploads`               | `PATCH /api/common/resource`           |
 *
 * 그리드 메타(`/api/common/gridsub`)·주문검색 팝업 메타(`/api/common/helper`)는 컬럼을 화면 상수로
 * 고정해 호출 자체를 없앴다. 근거: 계획 문서 2장.
 */
export const RETURN_WORK_SCAN_SUMMARY_URL = '/api/v1/return/work-scans/summary'
export const RETURN_WORK_SCAN_ITEMS_URL = '/api/v1/return/work-scans'
export const RETURN_WORK_SCAN_SAVE_URL = '/api/v1/return/work-scans/save'
export const RETURN_ORDER_SEARCH_URL = '/api/v1/return/management/order-search'
export const FILE_UPLOAD_URL = '/api/v1/common/file/uploads'
